import { defineStore } from 'pinia';
import { useStorage } from '@vueuse/core';
import { useLayout } from '@/layout/composables/layout';
const { changeThemeSettings } = useLayout();

export const useAppStore = defineStore({
    id: 'app_settings',

    state: () => ({
        app_settings: []
    }),

    getters: {
        getAppSettings: (state) => state.app_settings
    },

    actions: {
        async fetchData() {
            //
        },

        setTheme(mode) {
            const replaceTheme = mode == 'light' ? 'dark' : 'light';
            const elementId = 'theme-css';
            const linkElement = document.getElementById(elementId);
            const cloneLinkElement = linkElement.cloneNode(true);
            const newThemeUrl = linkElement.getAttribute('href').replace(replaceTheme, mode);
            cloneLinkElement.setAttribute('id', elementId + '-clone');
            cloneLinkElement.setAttribute('href', newThemeUrl);
            cloneLinkElement.addEventListener('load', () => {
                linkElement.remove();
                cloneLinkElement.setAttribute('id', elementId);
                changeThemeSettings('portal-one-' + mode, mode === 'dark');
            });
            linkElement.parentNode.insertBefore(cloneLinkElement, linkElement.nextSibling);

            const themePreference = useStorage('theme_preference');
            themePreference.value = mode;
        }
    }
});

export default useAppStore;
